import React from "react";
import ServicePage from "@/components/ServicePage";
import { infrarossiData } from "@/data/services";

export default function Infrarossi() {
    return <ServicePage data={infrarossiData} />;
}
